<template>
  <!-- 新课推荐 -->
  <div class="home-new">
    <HomePanel title="新课推荐" sub-title="大咖开讲 品质保障">
      <template #right><ShMore path="/video" /></template>
      <!-- 面板内容 -->
      <div ref="target" style="position: relative">
        <transition name="fade">
          <ul v-if="goods.length" class="goods-list">
            <li v-for="item in goods" :key="item.clID">
              <RouterLink
                target="_blank"
                :to="`/video/videodetail?clID=${item.clID}&id=${item.id}`"
              >
                <img v-lazy="item.coverImg" alt="" />
                <div class="pr-tag">
                  <i class="pr-year" title="课程年份">{{
                    item.grade.grYear
                  }}</i>
                  <i class="pr-way" title="学习方式">{{
                    item.grade.prTeachWayName
                  }}</i>
                </div>
                <p class="grade" v-if="item.grade.grName.length <= 4">
                  {{ item.grade.grName }}
                </p>
                <p class="grade1" v-if="item.grade.grName.length > 4">
                  {{ item.grade.grName }}
                </p>
                <p class="name ellipsis-2">
                  {{ item.grade.grYear }}{{ item.leName }}
                </p>
                <div class="price">
                  <span class="old-price">&yen;{{ item.grade.grPrice }}</span>
                  <span class="new-price">&yen;{{ item.grade.salePrice }}</span>
                </div>
              </RouterLink>
            </li>
          </ul>
          <HomeSkeleton v-else />
        </transition>
      </div>
    </HomePanel>
  </div>
</template>
<script>
import { ref } from "vue";
import { findNew } from "@/api/home";

import ShMore from "@/components/library/sh-more";
import HomePanel from "./home-panel";
import HomeSkeleton from "./home-skeleton";

import { useLazyData } from "@/hooks";

export default {
  name: "HomeNew",
  components: { HomePanel, ShMore, HomeSkeleton },
  setup() {
    const target = ref(null);
    const { result } = useLazyData(target, findNew);

    return { goods: result, target };
  },
};
</script>
<style scoped lang="less">
.goods-list {
  display: flex;
  justify-content: space-between;
  height: 300px;

  li {
    position: relative;
    width: 306px;
    height: 300px;
    background: #f4f4f4;
    .pr-tag {
      display: inline-block;
      position: absolute;
      top: 0px;
      right: 0px;
      .pr-way {
        height: 20px;
        text-align: center;
        line-height: 20px;
        color: #fff;
        font-size: 12px;
        background: @shColor;
        border-radius: 5px;
        padding-left: 5px;
        padding-right: 5px;
      }
      .pr-year {
        height: 20px;
        text-align: center;
        line-height: 20px;
        color: #fff;
        font-size: 12px;
        background: @shColor;
        border-radius: 5px;
        padding-left: 5px;
        padding-right: 5px;
        margin-right: 5px;
      }
    }
    .grade {
      position: absolute;
      font-weight: bold;
      top: 47.9%;
      left: 38.37%;
    }
    .grade1 {
      position: absolute;
      font-weight: bold;
      top: 47.9%;
      left: 34.37%;
    }

    .hoverShadow();

    img {
      width: 306px;
      height: 200px;
      border-radius: 8px;
    }
    span {
      margin-top: 10px;
      height: 60px;
      font-size: 16px;
      padding: 5px 15px 0 5px;
      text-align: left;
    }
    p {
      height: 60px;
      font-size: 16px;
      padding: 10px 15px 0 5px;
      text-align: left;
    }
    .price {
      display: flex;
      justify-content: space-around;
      .old-price {
        padding-left: 8px;
        color: @priceColor;
        font-size: 16px;
        height: 16px;
        text-decoration: line-through;
      }
      .new-price {
        margin-left: 8px;
        color: @priceColor;
        font-size: 16px;
        height: 16px;
      }
    }
  }
}
</style>
